module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/why-delete-my-issue-comment-24.vue");


//////////////////
// WEBPACK FOOTER
// ./en/faq/why-delete-my-issue-comment.md
// module id = 600
// module chunks = 181